import ConductorDashboard from './ConductorDashboard.js';

export default function Conductor() {
  return <ConductorDashboard />;
}
